
    import axios from 'axios';
    import { mapState } from 'vuex';
    import { OutgoingAffiliate } from '@roc/affiliate';
    import api from '@public/js/api';
    import Validator from '@components/Validator';
    import { BaseInput, BaseCheckbox } from '@components/form';
    import { prelaunchEmail as validatorGuards } from '../../../lib/validation/client-validators';

    export default {
        i18nOptions: { namespaces: ['email_collector', 'buttons'] },

        components: {
            BaseInput,
            BaseCheckbox,
            Validator,
            OutgoingAffiliate,
        },
        computed: {
            ...mapState(['app']),
        },

        data () {
            return {
                loading: false,
                showForm: true,
                showLimiter: false,
                success: false,
                tempProfile: {
                    email: undefined,
                    primaryOptIn: false,
                },
                validatorGuards,
            };
        },

        mounted () {
            const isLimited = this.getLimiterCookie();
            if (isLimited) {
                this.showLimiter = true;
            }
        },

        methods: {
            async preReg () {
                const {
                    email,
                    primaryOptIn,
                } = this.tempProfile;

                // const affiliate_id = this.$store.state.app.affiliateId;

                await axios.post(`${api.base}/prelaunch-email/submit`, {
                    email,
                    primaryOptIn,
                });
            },

            async doPreReg () {
                const { tempProfile } = this;

                tempProfile.locale = 'en_US';

                await this.$refs.validator.validate();

                if (this.$refs.validator.isValid) {
                    this.$webAnalytics.track('Prelaunch Form', 'Valid Submission');
                }
                else {
                    // Don't continue submitting.
                    return;
                }

                this.loading = true;

                try {
                    await this.preReg();
                    this.showSuccess();
                    this.setLimiterCookie();
                }
                catch (error) {
                    this.showForm = false;
                    this.success = false;
                }
            },

            showSuccess () {
                this.showForm = false;
                this.success = true;
                this.$emit('submitted');
            },

            getLimiterCookie () {
                return localStorage.getItem('emailEntered');
            },

            setLimiterCookie () {
                localStorage.setItem('emailEntered', true);
            },
        },
    };
